export const ReportsMutations = {}
